import React from 'react';
import { toArray } from 'lodash';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT, STATIC_ROOT } from '../../../constants';

import { hasCashback } from '../../../services/partner/utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import SvgComponent from '../../SvgComponent';
import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './ToolbarPage.scss';

export class ToolbarInstallationPage extends React.Component {
    render() {
        const { i18n, partners } = this.props;
        return (
            <main className="conteneur conteneur-mobile" id="p-toolbar">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.TOOLBAR_POST_INSTALL_PATH}`}
                />
                <LocalizedBreadcrumbItem to={PATH.TOOLBAR_POST_INSTALL_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.PAGE_TITLE}</h1>

                <div className="installation">
                    <h3>
                        <SvgComponent
                            src={`${STATIC_ROOT}/toolbar/picto-check.svg`}
                            width="23"
                            height="18"
                        />
                        {i18n.INSTALLATION_TEXT1}
                    </h3>
                    <p>{convertHtmlToReactDomWithParams(i18n.INSTALLATION_TEXT2, partners)}</p>
                </div>

                <h3 className="sectionTitle">{i18n.INSTALLATION_SECTION_TITLE}</h3>
                <div className="explanationContainer">
                    <div className="explanationBloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/toolbar/HowItWorkToolbarPicto1.svg`}
                            width="62"
                            height="62"
                        />
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT3)}</p>
                    </div>
                    <div className="explanationBloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/toolbar/HowItWorkToolbarPicto2.svg`}
                            width="62"
                            height="62"
                        />
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT4)}</p>
                    </div>
                    <div className="explanationBloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/toolbar/HowItWorkToolbarPicto3.svg`}
                            width="62"
                            height="62"
                        />
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT5)}</p>
                    </div>
                </div>

                <div className="footer">
                    <img
                        src={`${STATIC_ROOT}/toolbar/toolbar-footer.png`}
                        width="1014"
                        height="341"
                        alt="toolbar footer"
                    />
                    <p>{i18n.FOOTER_TEXT}</p>
                </div>
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.TOOLBAR,
        partners: toArray(state.partner.partners).filter(partner => hasCashback(partner)).length
    };
};

export default withTemplate(connect(mapStateToProps)(ToolbarInstallationPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/toolbar/ToolbarInstallationPage.js